import React from 'react';

import {ConfirmEmailScreen} from 'features/auth';

const ConfirmEmailPage: React.FC = () => <ConfirmEmailScreen />;

export default ConfirmEmailPage;
